import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ArrowPathIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import { transferStoragePath } from '../services/storageService';

const MigrationBanner: React.FC = () => {
  const { t } = useTranslation();
  const transferPath = transferStoragePath({ resume: true });

  return (
    <Link
      to={transferPath}
      className="block rounded-lg border border-amber-500/40 bg-amber-500/10 px-4 py-3 text-sm transition-colors hover:bg-amber-500/15 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-500/50"
      data-testid="migration-banner"
      aria-label={t('migration.banner.viewProgress', 'View migration progress')}
    >
      <div className="flex items-start gap-3">
        <ArrowPathIcon className="w-5 h-5 flex-shrink-0 mt-0.5 text-amber-600 animate-spin" />
        <div className="min-w-0 flex-1">
          <p className="font-medium text-[var(--color-text)]">{t('migration.banner.title')}</p>
          <p className="mt-1 text-[var(--color-muted)]">{t('migration.banner.message')}</p>
          <p className="mt-2 text-xs font-medium text-amber-700 flex items-center gap-0.5">
            {t('migration.banner.viewProgress', 'View progress')}
            <ChevronRightIcon className="w-3.5 h-3.5" aria-hidden />
          </p>
        </div>
      </div>
    </Link>
  );
};

export default MigrationBanner;
